import { tr } from '@/i18n/tr';
import styles from './loadMore.module.scss';

interface Props {
  /** How many rows are still hidden. Zero renders nothing. */
  remaining: number;
  onClick: () => void;
  className?: string;
}

/**
 * The one "Daha fazla yükle" in the app. Paired with useIncrementalList, but
 * usable on its own by anything that pages server-side.
 *
 * Renders nothing at zero rather than a disabled button: a control that can
 * never do anything is noise, and the list ending is already the signal.
 */
export function LoadMore({ remaining, onClick, className }: Props) {
  if (remaining <= 0) return null;

  return (
    <button type="button" className={`${styles.button} ${className ?? ''}`} onClick={onClick}>
      {tr.common.loadMore}
      <span className={styles.count}>{tr.common.loadMoreRemaining(remaining)}</span>
    </button>
  );
}
